"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var FacetFiltersForm = /*#__PURE__*/function (_HTMLElement) {
  _inherits(FacetFiltersForm, _HTMLElement);
  var _super = _createSuper(FacetFiltersForm);
  function FacetFiltersForm() {
    var _this;
    _classCallCheck(this, FacetFiltersForm);
    _this = _super.call(this);
    _this.onActiveFilterClick = _this.onActiveFilterClick.bind(_assertThisInitialized(_this));
    _this.siblingBasedListing = _this.dataset.siblingBasedListing;
    _this.facetCheckboxes = Array.from(_this.getElementsByClassName('facet-checkbox'));
    FacetFiltersForm.gridType = _this.dataset.originalGridType;
    FacetFiltersForm.siblingGridId = 'main-collection-product-grid-sibling';
    FacetFiltersForm.bulkGridId = 'main-collection-product-grid-bulk';
    FacetFiltersForm.standardGridId = 'main-collection-product-grid-standard';
    FacetFiltersForm.searchGrid = 'main-search';

    // both functions below used for selecting and deselecting facet filter to add custom css for regluar swatches and colour
    _this.attachColourFacetCheckboxListeners();
    _this.attachFacetCheckboxListeners();
    _this.openActiveGroups();
    // this.debouncedOnSubmit used for submitted a selected facet
    _this.debouncedOnSubmit = debounce(function (event) {
      _this.onSubmitHandler(event);
    }, 500);
    _this.querySelector('form').addEventListener('input', _this.debouncedOnSubmit.bind(_assertThisInitialized(_this)));

    // this.closeOtherFilters used for opening and closing details and summary's
    _this.querySelectorAll('.facets__main details').forEach(function (detailsElement) {
      detailsElement.addEventListener('click', _this.closeOtherFilters);
      detailsElement.addEventListener('keydown', _this.closeOtherFilters);
    });
    _this.visualFilterHook = new Event('visualFilterHook', {
      bubbles: true
    });
    return _this;
  }
  _createClass(FacetFiltersForm, [{
    key: "attachColourFacetCheckboxListeners",
    value: function attachColourFacetCheckboxListeners() {
      this.querySelectorAll('.facets__checkbox-colour-swatch').forEach(function (checkbox) {
        checkbox.addEventListener('change', function (event) {
          var li = checkbox.closest('.facets__item');
          if (li) {
            if (checkbox.checked) {
              li.classList.add('facets__item--selected');
            } else {
              li.classList.remove('facets__item--selected');
            }
          }
        });
      });
    }
  }, {
    key: "attachFacetCheckboxListeners",
    value: function attachFacetCheckboxListeners() {
      this.querySelectorAll('.facets__checkbox').forEach(function (checkbox) {
        checkbox.addEventListener('change', function (event) {
          var li = checkbox.closest('.facets__item');
          if (li) {
            if (checkbox.checked) {
              li.classList.add('facets__item--selected');
            } else {
              li.classList.remove('facets__item--selected');
            }
          }
        });
      });
    }
  }, {
    key: "onSubmitHandler",
    value: function onSubmitHandler(event, externalSort) {
      event.preventDefault();
      if (this.sideBarMode) {
        var formData = new FormData(event.target.closest('form'));
        var searchParams = new URLSearchParams(formData).toString();
        var sortParamString = 'sort';
        var filterParamString = 'filter';
        if (externalSort) {
          if (FacetFiltersForm.searchParamsPrev.includes(filterParamString) && !FacetFiltersForm.searchParamsPrev.includes(sortParamString)) {
            //S3 sort with prior filter params and no prior sortby params
            searchParams = "".concat(FacetFiltersForm.searchParamsPrev, "&").concat(searchParams);
          } else if (FacetFiltersForm.searchParamsPrev.includes(filterParamString) && FacetFiltersForm.searchParamsPrev.includes(sortParamString)) {
            //s4 sort with prior filter params and prior sortby params
            searchParams = FacetFiltersForm.searchParamsPrev.split(sortParamString)[0] + searchParams;
          }
        }
        if (FacetFiltersForm.searchParamsPrev.includes(sortParamString) && FacetFiltersForm.searchParamsPrev.includes(filterParamString)) {
          var sortParam = FacetFiltersForm.searchParamsPrev.split("&".concat(sortParamString))[1];
          searchParams = "".concat(searchParams, "&").concat(sortParamString).concat(sortParam);
        } else if (FacetFiltersForm.searchParamsPrev.includes(sortParamString) && !FacetFiltersForm.searchParamsPrev.includes(filterParamString)) {
          var _sortParam = FacetFiltersForm.searchParamsPrev.split(sortParamString)[1];
          searchParams = "".concat(searchParams, "&").concat(sortParamString).concat(_sortParam);
        }
        FacetFiltersForm.renderPage(searchParams, event);
      } else {
        var _formData = new FormData(event.target.closest('form'));
        var _searchParams = new URLSearchParams(_formData).toString();
        var visualFilterParams = this.handleVisualFilters();
        var existingParams = window.location.search.includes('&') ? window.location.search.split('?')[1].split('&') : [];
        if (existingParams.length > 1) {
          existingParams.forEach(function (param, index) {
            if (param.includes('filter.p') || param.includes('filter.v') || param.includes('sort_by')) {
              // LOGIC DIDN'T WORK WITH INVERTED INCLUDES COMBINED WITH OR CONDIITONAL, BUT WE ONLY NEED THE ELSE
            } else {
              _searchParams = _searchParams + param.length > 0 ? "&".concat(param) : _searchParams;
            }
          });
        }
        if (visualFilterParams.length > 0) {
          _searchParams = _searchParams === '' ? '' : "".concat(_searchParams, "&").concat(visualFilterParams);
        } else {
          _searchParams = _searchParams === '' ? '' : _searchParams;
        }
        FacetFiltersForm.renderPage(_searchParams, event);
      }
    }
  }, {
    key: "handleVisualFilters",
    value: function handleVisualFilters() {
      var _this2 = this;
      this.visualFilterQuery = '';
      document.querySelectorAll('visual-filter').forEach(function (vf) {
        if (vf.visualFilterApplied === true) {
          _this2.visualFilterQuery = "".concat(vf.paramString, "=").concat(vf.filterValue);
          return;
        }
      });
      return this.visualFilterQuery;
    }
  }, {
    key: "onActiveFilterClick",
    value: function onActiveFilterClick(event) {
      var _this3 = this;
      event.preventDefault();
      FacetFiltersForm.toggleActiveFacets();
      this.handleVisualFilters();
      var paramsAsArray = window.location.search.split('?')[1].split('&');
      var proposedUrl = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
      if (proposedUrl === '') {
        var preservedParamCount = 0;
        paramsAsArray.forEach(function (param) {
          if (!param.includes('filter.p') && !param.includes('sort_by') && !param.includes('filter.v')) {
            proposedUrl = proposedUrl + "".concat(preservedParamCount === 0 ? '' : '&').concat(param);
            preservedParamCount++;
          }
        });
        proposedUrl = this.visualFilterQuery !== '' ? "".concat(proposedUrl, "&").concat(this.visualFilterQuery) : proposedUrl;
      } else {
        if (paramsAsArray.length > 0) {
          paramsAsArray.forEach(function (param, index) {
            if (!param.includes('filter.p') && !param.includes('sort_by') && !param.includes('filter.v')) {
              if (proposedUrl.indexOf('=') === -1) {
                if (_this3.visualFilterQuery != '') {
                  proposedUrl = proposedUrl.includes(_this3.visualFilterQuery) ? "".concat(proposedUrl, "&").concat(param) : "".concat(proposedUrl).concat(_this3.visualFilterQuery, "&").concat(param);
                } else {
                  proposedUrl = "".concat(proposedUrl, "&").concat(param);
                }
              }
              proposedUrl = proposedUrl.indexOf('=') === -1 ? "".concat(proposedUrl).concat(param) : "".concat(proposedUrl, "&").concat(param);
            }
          });
        }
      }
      FacetFiltersForm.renderPage(proposedUrl);
    }

    // Expands <details> sections that contain checkboxes marked as checked via the 'checked' attribute
  }, {
    key: "openActiveGroups",
    value: function openActiveGroups() {
      this.facetCheckboxes.forEach(function (checkbox) {
        if (checkbox.firstElementChild.hasAttribute('checked')) {
          checkbox.closest('details').setAttribute('open', 'open');
        }
      });
    }
  }, {
    key: "closeOtherFilters",
    value: function closeOtherFilters(event) {
      var clickedDetails = event.target.closest('details');
      this.closest('.facets__main').querySelectorAll('details').forEach(function (details) {
        if (details !== clickedDetails) {
          details.removeAttribute('open');
          details.querySelector('summary').setAttribute('aria-expanded', false);
        }
      });
    }
  }], [{
    key: "setListeners",
    value: function setListeners() {
      var onHistoryChange = function onHistoryChange(event) {
        var visualFilters = document.querySelectorAll('visual-filter');
        var visualFilterTriggered = false;
        if (visualFilters.length > 0) {
          visualFilters.forEach(function (vf) {
            if (event.state.includes("".concat(vf.filterValue)) && visualFilterTriggered === false) {
              visualFilterTriggered = true;
              vf.visualFilterApplied = false;
              vf.handleVisualFilter();
              return;
            } else {
              return;
            }
          });
        }
        if (!visualFilterTriggered) {
          var searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
          if (searchParams === FacetFiltersForm.searchParamsPrev) return;
          FacetFiltersForm.renderPage(searchParams, null, false);
        }
      };
      window.addEventListener('popstate', onHistoryChange);
    }
  }, {
    key: "toggleActiveFacets",
    value: function toggleActiveFacets() {
      var disable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      document.querySelectorAll('.js-facet-remove').forEach(function (element) {
        element.classList.toggle('disabled', disable);
      });
    }

    // renderPage renders the product grid
    // Filtering by colour renders stardard Product Grid
    // Every other filter shows sibling Product Grid
  }, {
    key: "renderPage",
    value: function renderPage(searchParams, event) {
      var updateURLHash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      FacetFiltersForm.searchParamsPrev = searchParams;
      var gridType;
      if (window.location.href.includes('search?')) {
        gridType = 'search';
      } else {
        if (searchParams.includes('filter.p.m.filter.colour')) {
          gridType = 'standard';
        } else if (!searchParams.includes('filter.p.m.filter.colour') && searchParams.includes('filter')) {
          gridType = 'sibling';
        } else {
          gridType = FacetFiltersForm.gridType;
        }
      }
      var sections = FacetFiltersForm.getSections(gridType);
      var countContainer = document.getElementById('ProductCount');
      var loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
      loadingSpinners.forEach(function (spinner) {
        return spinner.classList.remove('hidden');
      });
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
      if (countContainer) {
        countContainer.classList.add('loading');
      }
      sections.forEach(function (section) {
        var url = "".concat(window.location.pathname, "?section_id=").concat(section.section, "&").concat(searchParams);
        var filterDataUrl = function filterDataUrl(element) {
          return element.url === url;
        };
        FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event);
      });
      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.remove('loading');
    }
  }, {
    key: "renderSectionFromFetch",
    value: function renderSectionFromFetch(url, event) {
      fetch(url).then(function (response) {
        return response.text();
      }).then(function (responseText) {
        var html = responseText;
        FacetFiltersForm.filterData = [].concat(_toConsumableArray(FacetFiltersForm.filterData), [{
          html: html,
          url: url
        }]);
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
    }
  }, {
    key: "renderSectionFromCache",
    value: function renderSectionFromCache(filterDataUrl, event) {
      var html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
    }
  }, {
    key: "renderProductGridContainer",
    value: function renderProductGridContainer(html) {
      document.querySelector('#ProductGridContainer .collection.page-width') ? document.querySelector('#ProductGridContainer .collection.page-width').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('#ProductGridContainer .collection.page-width').innerHTML : document.querySelector('#ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
      customizerObj.refreshCustomizationInDom();
    }
  }, {
    key: "renderProductCount",
    value: function renderProductCount(html) {
      var count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount') ? new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML : null;
      var container = document.getElementById('ProductCount');
      container ? container.innerHTML = count : null;
      container ? container.classList.remove('loading') : null;
      var loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
      loadingSpinners.forEach(function (spinner) {
        return spinner.classList.add('hidden');
      });
    }
  }, {
    key: "renderFilters",
    value: function renderFilters(html, event) {
      var parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      var facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersForm .js-filter');
      var matchesIndex = function matchesIndex(element) {
        var jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
      };
      var facetsToRender = Array.from(facetDetailsElements).filter(function (element) {
        return !matchesIndex(element);
      });
      var countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
      facetsToRender.forEach(function (element) {
        document.querySelector(".js-filter[data-index=\"".concat(element.dataset.index, "\"]")) ? document.querySelector(".js-filter[data-index=\"".concat(element.dataset.index, "\"]")).innerHTML = element.innerHTML : null;
      });
      var presentFacets = document.querySelectorAll('.js-filter.details-item');
      var presentFacetsLength = presentFacets.length - 1;
      for (var i = facetsToRender.length; i < presentFacetsLength; i++) {
        presentFacets[i].remove();
      }

      // renderActiveFacets adds tabs
      FacetFiltersForm.renderActiveFacets(parsedHTML);
      if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
      document.querySelectorAll('facet-filters-form').forEach(function (form) {
        form.attachColourFacetCheckboxListeners();
        form.attachFacetCheckboxListeners();
      });
    }
  }, {
    key: "renderActiveFacets",
    value: function renderActiveFacets(html) {
      var activeFacetElementSelectors = ['.active-facets'];
      activeFacetElementSelectors.forEach(function (selector) {
        var activeFacetsElement = html.querySelector(selector);
        if (!activeFacetsElement) return;
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      });
      FacetFiltersForm.toggleActiveFacets(false);
    }
  }, {
    key: "renderCounts",
    value: function renderCounts(source, target) {
      var targetElement = target.querySelector('.facets__selected');
      var sourceElement = source.querySelector('.facets__selected');
      if (sourceElement && targetElement) {
        target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
      }
    }
  }, {
    key: "updateURLHash",
    value: function updateURLHash(searchParams) {
      history.pushState({
        searchParams: searchParams
      }, '', "".concat(window.location.pathname).concat(searchParams && '?'.concat(searchParams)));
      document.dispatchEvent(FacetFiltersForm.visualFilterHook, 'visualFilterHook');
    }
  }, {
    key: "getSections",
    value: function getSections(gridType) {
      if (gridType === 'bulk' && document.getElementById('product-grid').dataset.bulkGridId !== undefined) {
        return [{
          section: document.getElementById('product-grid').dataset.bulkGridId
        }];
      } else {
        if (FacetFiltersForm.searchParamsPrev.includes('filter.p.m.filter.colour')) {
          return [{
            section: document.getElementById('product-grid').dataset.standardGridId
          }];
        } else {
          switch (gridType) {
            case "sibling":
              return [{
                section: FacetFiltersForm.siblingGridId
              }];
              break;
            case "standard":
              return [{
                section: FacetFiltersForm.standardGridId
              }];
              break;
            case "bulk":
              return [{
                section: FacetFiltersForm.bulkGridId
              }];
              break;
            case "search":
              return [{
                section: FacetFiltersForm.searchGrid
              }];
              break;
            default:
              return [{
                section: FacetFiltersForm.standardGridId
              }];
              break;
          }
        }
      }
    }
  }]);
  return FacetFiltersForm;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
_defineProperty(FacetFiltersForm, "visualFilterHook", new Event('visualFilterHook', {
  bubbles: true
}));
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
var PriceRange = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(PriceRange, _HTMLElement2);
  var _super2 = _createSuper(PriceRange);
  function PriceRange() {
    var _this4;
    _classCallCheck(this, PriceRange);
    _this4 = _super2.call(this);
    _this4.querySelectorAll('input').forEach(function (element) {
      return element.addEventListener('change', _this4.onRangeChange.bind(_assertThisInitialized(_this4)));
    });
    _this4.setMinAndMaxValues();
    return _this4;
  }
  _createClass(PriceRange, [{
    key: "onRangeChange",
    value: function onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }
  }, {
    key: "setMinAndMaxValues",
    value: function setMinAndMaxValues() {
      var inputs = this.querySelectorAll('input');
      var minInput = inputs[0];
      var maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute('max', maxInput.value);
      if (minInput.value) maxInput.setAttribute('min', minInput.value);
      if (minInput.value === '') maxInput.setAttribute('min', 0);
      if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }
  }, {
    key: "adjustToValidValues",
    value: function adjustToValidValues(input) {
      var value = Number(input.value);
      var min = Number(input.getAttribute('min'));
      var max = Number(input.getAttribute('max'));
      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }]);
  return PriceRange;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('price-range', PriceRange);
var FacetRemove = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(FacetRemove, _HTMLElement3);
  var _super3 = _createSuper(FacetRemove);
  function FacetRemove() {
    var _this5;
    _classCallCheck(this, FacetRemove);
    _this5 = _super3.call(this);
    _this5.querySelector('a').addEventListener('click', function (event) {
      event.preventDefault();
      var form = _this5.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
    return _this5;
  }
  return _createClass(FacetRemove);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('facet-remove', FacetRemove);